<template>
  <div class="wrapper shop-wrapper">
    <app-bar position="top" width="750px" :data-id="pid" data-type="31"></app-bar>
    <swiper :options="swiperOption" ref="mySwiper" class="good-banner">
      <swiper-slide v-for="item in photos" :key="item.id">
        <!-- image -->
        <template v-if="item.resourceType === 0">
          <img v-lazy="getImageUrl(item.imageUrl, '?imageView2/1/w/750')" />
        </template>
        <!-- video -->
        <template v-if="item.resourceType === 1">
          <video x5-video-player-type="h5" x5-video-player-fullscreen="true" preload="auto" webkit-playsinline playsinline controls :src="item.resourceUrl" :poster="getImageUrl(item.imageUrl, '?imageView2/1/w/750')">
            <p>你的浏览器不支持HTML5 Video元素。</p>
          </video>
        </template>
      </swiper-slide>
      <div class="pagination" slot="pagination">
        <div class="swiper-pagination"></div>
      </div>
    </swiper>
    <section class="section section-good-info">
      <h1 class="title">
        <span class="tag" v-if="info.titleTag">{{info.titleTag}}</span>
        {{info.name}}
      </h1>
      <div class="subject" v-if="info.shortSubject">{{info.shortSubject}}</div>
      <div class="content">
        <span class="priceTag" v-if="info.priceTag">{{info.priceTag}}</span>
        <div class="" v-html="getPriceCreditHtml(info.sellPrice, info.creditPrice)"></div>
        <span class="originPrice" v-if="info.originPrice">
          <em>¥</em>{{info.originPrice}}</span>
        <span class="totalCount" v-if="false">仅剩{{goodCount}}件</span>
      </div>
    </section>
    <buy-cell v-model="visible" :sku-list="skuList" @sku-change="skuChange" v-if="skuList && goodCount"></buy-cell>
    <section class="section section-good-detail">
      <h2 class="title">商品介绍 ·</h2>
      <div class="content" v-html="info.detail"></div>
    </section>
    <div class="position-wrapper">
      <div class="inner">
        <div class="button primary-button" v-if="goodCount" @click="visible = !visible">
          <span class="text">立即购买</span>
        </div>
        <div class="button disable-button" v-else>
          <span class="text">已售罄</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// 组件
import 'swiper/dist/css/swiper.css'
import AppBar from '@/components/AppBar'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import BuyCell from '@/components/BuyCell'

// 接口
import { getGoodDetail } from '@/api/shop'
// 方法
import { share } from '@/utils/share'
import { getImageUrl, getPriceCreditHtml } from '@/utils/utils'

export default {
  name: 'ShopItem',
  components: { AppBar, swiper, swiperSlide, BuyCell },
  metaInfo: { title: '商品详情' },
  data() {
    return {
      pid: '',
      swiperOption: {
        slidesPerView: 1,
        mousewheel: true,
        pagination: {
          el: '.swiper-pagination',
          type: 'fraction'
        }
      },
      info: {}, // 商品信息
      photos: [], // 商品图
      skuList: [], // sku
      selectedSku: {},
      visible: false
    }
  },
  computed: {
    goodCount() {
      return this.skuList.reduce((count, item) => {
        return count + item.balanceCount
      }, 0)
    }
  },
  methods: {
    getImageUrl,
    getPriceCreditHtml,
    getDetail() {
      getGoodDetail({ id: this.pid }).then(response => {
        let data = response.data // 商品信息
        this.info = Object.assign({}, this.info, data.goodInfo)
        this.info.detail = data.goodAttr.detail || ''
        // 商品图
        this.photos = data.goodPhotoList || []
        // sku
        this.skuList = data.goodStockList
        this.selectedSku = this.skuList[0]
        // 设置微信分享
        share(data.shareCard)
      })
    },
    skuChange(item) {
      this.selectedSku = item
    }
  },
  created() {
    this.pid = this.$route.query.id || this.$route.params.id
    this.getDetail()
  }
}
</script>
<style src='@/assets/css/shop.css'></style>
